import "core-js/modules/es.array.map.js";
import React from 'react';
import styles from "./Breakpoint.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var Breakpoint = function Breakpoint(_ref) {
  var breakpoint = _ref.breakpoint,
    children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: styles[breakpoint],
    children: React.Children.map(children, function (child, i) {
      if (child) {
        return /*#__PURE__*/_jsx("div", {
          className: i === 0 ? styles.below : styles.above,
          children: child
        });
      }
    })
  });
};